module.exports = __webpack_public_path__ + "static/img/主图2-2.5dfe8908.png";